// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","iconPlus":"_39g3_","circle":"_1L32O","cross":"_2xdKv"};